import { Integrations, StepSource } from '@sworkit/api';
import { openInNewWindow } from './app';
import { fitbitRedirect } from './oauth-consts';
import { updateUserIntegrations } from '../actions/user';
import { ModalOptions, modalController } from '@ionic/core';

export function linkMyFitnessPal(uid: string) {
  // const authUrl = `https://www.myfitnesspal.com/oauth2/authorize?client_id=sworkit&scope=diary&redirect_uri=https://us-central1-sworkit-user.cloudfunctions.net/authMFP&access_type=offline&response_type=code&uid=${uid}`;
  const authUrl = `https://www.myfitnesspal.com/oauth2/authorize?client_id=sworkit&scope=diary&access_type=offline&response_type=code&state=${uid}&redirect_uri=http://m.sworkit.com/mfp-auth.html`;
  openInNewWindow(authUrl);
}

export function unlinkMFP(refresh_token: string) {
  var unauthorizeURL = `https://www.myfitnesspal.com/oauth2/revoke?client_id=sworkit&refresh_token=${refresh_token}`;
  return fetch(unauthorizeURL, {
    method: 'GET',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  });
}

export function linkStrava(uid: string) {
  // @todo once old app is gone - have strava update our endpoint
  // const authUrl = `https://www.strava.com/oauth/authorize?client_id=22376&scope=write&redirect_uri=https://us-central1-sworkit-user.cloudfunctions.net/authStrava&approval_prompt=force&state=mobile-app&response_type=code&uid=${uid}`;

  const authUrl = `https://www.strava.com/oauth/authorize?client_id=22376&scope=write&redirect_uri=http://sworkit-api.herokuapp.com/strava-auth&approval_prompt=force&state=mobile-app&response_type=code&state=${uid}`;

  openInNewWindow(authUrl);
}

export function linkFitbit(uid: string) {
  const clientId = fitbitRedirect?.includes('app.sworkit.com') ? '238KFD': '238KF2'  
  const authUrl = `https://www.fitbit.com/oauth2/authorize?response_type=code&client_id=${clientId}&redirect_uri=${fitbitRedirect}&scope=activity&state=${uid}&expires_in=604800`;
  openInNewWindow(authUrl);
}

export function revokeFitbitOAuth() {
  //todo: callable function

}

export function unlinkStrava(access_token: string) {
  var unauthorizeURL = `https://www.strava.com/oauth/deauthorize&access_token=${access_token}`;
  return fetch(unauthorizeURL, {
    method: 'GET',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  });
}

export const healthIntegrationKeyToName = {
  strava: 'Strava',
  mfp: 'MyFitnessPal',
  fitbit: 'Fitbit',
  "apple-health": "Apple Health",
  "google-fit": "Google Fit",
  'health-connect': "Health Connect" //TODO why isn't the translate(key) working? 
}

export const integrationFirestoreMap = {
  strava: 'strava',
  mfp: 'myFitnessPal',
  fitbit: 'fitbit'
}

export function isFitbitErroring(integrations: Integrations, stepSource: StepSource) {
  if (integrations?.fitbit?.readWorkoutsFrom || integrations?.fitbit?.writeWorkoutsTo || stepSource === 'fitbit') {
    return !Boolean(integrations?.fitbit?.access_token)
  }
  return false
}

export async function showIntegrationSettings(
  service: StepSource,
  displayManualSync: boolean,
  referringPage?: string
) {
  const modalCtrl = modalController;
  const modalOptions: ModalOptions = {
    backdropDismiss: false,
    component: 'sw-connect-service-modal',
    cssClass: 'fullscreen-modal',
    componentProps: {
      modalCtrl,
      service,
      displayManualSync,
      referringPage
    },
  };
  const modal = await modalCtrl.create(modalOptions);
  await modal.present();
  const res = await modal.onDidDismiss();
  const firestoreKey = integrationFirestoreMap[service];
  if (res.data?.disconnectOnClose && firestoreKey) {
    updateUserIntegrations({
      [firestoreKey]: {
        accessToken: null,
      },
    });
  }

  
  
}
